import Switch, { SwitchItem } from "ui/atoms/Switch/Switch";
import Button from "ui/atoms/Button/Button";
import { State } from "../state/reducer";
import { useState } from "react";
import { useAudioContextReady } from "util/audioContext";

interface Props {
  state: State;
  updatePlaybackState?: (state: State["playbackState"]) => void;
  onRequestSubmit?: () => void;
  submitInProgress: boolean;
}

export default function Toolbar({
  state,
  updatePlaybackState,
  onRequestSubmit,
  submitInProgress,
}: Props) {
  const [clickedOnce, setClickedOnce] = useState(false);
  const [audioCtxReady] = useAudioContextReady();

  return (
    <div className="flex items-center justify-between">
      {updatePlaybackState && (
        <div
          className={audioCtxReady && !clickedOnce ? "animate-pulse" : ""}
          onClick={() => {
            if (clickedOnce) {
              return;
            }

            setClickedOnce(true);
          }}
        >
          <Switch
            size={"large"}
            wholeButtonToggle
            value={state.playbackState}
            onChange={updatePlaybackState}
            items={items}
          />
        </div>
      )}

      <div className="flex">
        <Button
          theme="green"
          onClick={onRequestSubmit}
          size="large"
          loading={submitInProgress}
        >
          Submit
        </Button>
      </div>
    </div>
  );
}

const items: SwitchItem<State["playbackState"]>[] = [
  { label: { mobile: "Mix", desktop: "Your Mix" }, value: "mix" },
  {
    label: { mobile: "Ref", desktop: "Reference" },
    value: "reference",
  },
];
